import type { Job } from "../types/job";
export const STAGES = ["New", "Apply Now", "Applied", "Human Contact Found", "Outreach Sent", "Follow-Up Due", "Interview", "Closed"] as const;
export interface Pipeline { stage: typeof STAGES[number]; nextAction: string; followUpAt: string | null; contactUrl: string; notes: string }
export const EMPTY_PIPELINE: Pipeline = { stage: "New", nextAction: "", followUpAt: null, contactUrl: "", notes: "" };
export interface Radar {
  score: number; components: { fit: number; freshness: number; accessibility: number; hiringSpeed: number };
  firstSeen: string | null; firstSeenAgeHours: number | null; freshnessBand: string; legacy: boolean;
  directApplyUrl: string | null; reasons: string[]; penalties: { reason: string; points: number }[];
  unknowns: string[]; resumeTrack: string; contactEvidence: string | null; speedEvidence: string | null;
  outreachAction: string; actionable: boolean;
}
export type RadarView = "Apply Now" | "Pipeline" | "All signals" | "Watchlist";
export function due(job: Job, now = Date.now()) {
  const p = job.pipeline;
  return Boolean(p && p.stage !== "Closed" && (p.stage === "Follow-Up Due" || (p.followUpAt && Date.parse(p.followUpAt) <= now)));
}
export function radarQueue(jobs: Job[], view: RadarView) {
  const sorted = [...jobs].sort((a, b) => (b.radar?.score ?? 0) - (a.radar?.score ?? 0) || a.id.localeCompare(b.id));
  if (view === "Apply Now") return sorted.filter(j => j.radar?.actionable && ["New", "Apply Now"].includes(j.pipeline?.stage ?? "New")).slice(0, 15);
  if (view === "Pipeline") return sorted.filter(j => j.pipeline && j.pipeline.stage !== "New").sort((a, b) => Number(due(b)) - Number(due(a)));
  return sorted;
}
export function seenLabel(job: Job) {
  if (!job.radar) return "Simulation · no observed age";
  if (job.radar.legacy) return "Legacy history · age uncertain";
  const hours = job.radar.firstSeenAgeHours;
  return hours == null ? "First seen unknown" : `First seen ${hours < 1 ? "<1" : Math.floor(hours)}h ago · ${job.radar.freshnessBand}`;
}

export interface WatchCompany { id: string; name: string; provider: string; scope: string; website?: string; status: { last_success_at: string | null; cooldown_until: string | null } | null }
